$(function() {
  $('.mega-menu .mega-menu__content .mega-menu-close').click(function() { // when a .myDiv is clicked
    $('#Details-HeaderMenu-1').removeAttribute("open");
  })
  $('.ring-overlay-open').click(function() { // when a .myDiv is clicked
    $('.ring-overlay-wrapper').slideDown().addClass("open");
  })
    $('.ring-overlay-close').click(function() { // when a .myDiv is clicked
    $('.ring-overlay-wrapper').slideUp().removeClass("open");
  })

 
})